import { useMemo } from 'react';

import { DateTime } from 'luxon';

import { ChatVisibilityType, Message } from '@/models/ChatModel.ts';
import { Queries } from '@/queries/Queries.ts';
import { toDateTime } from '@/utils/dateUtils.ts';

export type ChatDailyContent = {
  sentDate: DateTime;
  messages: Message[];
};

export const useChatMessageContent = (
  patientId: string,
  visibility: ChatVisibilityType,
) => {
  const messages = Queries.chat.useChat({
    subjectId: patientId,
    visibility: visibility,
  });

  return useMemo(() => {
    return Object.values(
      messages.reduce<ChatDailyContent[]>((acc, message) => {
        const sentDate = toDateTime(message.createdAt).startOf('day');
        const messageDate = sentDate.startOf('day').toMillis();
        const currentDay = acc.find(e => e.sentDate.toMillis() === messageDate);
        if (currentDay) {
          currentDay.messages.push(message);
        } else {
          acc.push({ sentDate, messages: [message] });
        }

        return acc;
      }, []),
    );
  }, [messages]);
};
